function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabGeneralView from '@/components/tableau/workbook/TabGeneralView';
import TabColumnView from '@/components/tableau/workbook/TabColumnView';
import TabViewsView from '@/components/tableau/workbook/TabViewsView';
import TabBusinessTermDashboard from '@/components/tableau/workbook/TabBusinessTermDashboard';
import DashboardTabLineage from '@/modules/tasks/tableau/components/dashboard/DashboardTabLineage';
import TabHistoryLogView from '@/components/tableau/TabHistoryLogView';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW, GA_EVENTS } from '@/js/constants';
import tasks from '@/js/tasks';
import { mapState } from 'vuex';
export default {
  name: 'FormMetaDashboard',
  components: {
    TabGeneralView: TabGeneralView,
    TabColumnView: TabColumnView,
    DashboardTabLineage: DashboardTabLineage,
    TabHistoryLogView: TabHistoryLogView,
    TabViewsView: TabViewsView,
    TabBusinessTermDashboard: TabBusinessTermDashboard
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      // email_regex: new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+" + `@${window.userInfo.domain}$`),
      email_regex: new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}\.[a-z]{2,3}'),
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      showDownloadCsv: true,
      showBtnAceptar: true,
      txtCancelar: 'Cancel',
      environt_initial: '',
      objetoInicial: null,
      valid: {
        organization: true,
        data_operator: true,
        kdomain: true,
        ksubdomain: true,
        object_description: true,
        response_text: true
      },
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      tabActive: 'GENERAL',
      tab: null,
      validform: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    isShowWorkFlow: function isShowWorkFlow() {
      return this.isChangeRequest === 'APPROVE_OWNER';
    },
    composeName: function composeName() {
      return "DASHBOARD: ".concat(this.item.path_name, "/").concat(this.item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
    }
  }),
  created: function created() {
    this.environt_initial = this.item['environment'];
    this.objetoInicial = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    onCancel: function onCancel() {
      this.$emit('onCloseModal');
    },
    onReject: function onReject() {
      var _this = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Response reason';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response: this.ds_response_text,
        domain: window.userInfo.domain
      }, this.item), {}, {
        status: 'REJECTED',
        type_flow: this.isChangeRequest
      });
      TableauDashboardService.tableauWorkBookSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          tasks.toast.success("Solicitud rechazada correctamente.");
          if (_this.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.OWNERSHIP,
              object: 'tbl_dashboard',
              domain_object: _this.item.organization,
              operator: _this.stringToHash(_this.item.data_operator),
              company_code: _this.companyCode,
              id_object: _this.item.id,
              hash_email: _this.stringToHash(userInfo.email),
              module: 'data_platform',
              status: 'rejected'
            });
          }
          _this.onCancel();
        } else {
          tasks.toast.error(res.message);
        }
      });
    },
    onSave: function onSave() {
      var _this2 = this;
      var formElement = this.$refs.form;
      console.log('form:', formElement.validate());
      if (formElement.validate()) {
        if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
          if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
            var workbook = {
              domain: window.userInfo.domain,
              workbook: this.item
            };
            TableauDashboardService.tableauWorkBookAddUpdate(workbook).then(function (res) {
              if (res.success && res.code === 200) {
                if (res.success) {
                  tasks.toast.success('Workbook fields updated!');
                  // this.$toast.success("Workbook fields updated!")
                  _this2.onCancel();
                  _this2.$emit('onSave', workbook.workbook);
                } else {
                  tasks.toast.error(res.message);
                  // this.$toast.warning(res.message)
                  _this2.onCancel();
                }
              }
            });
          } else {
            var _workbook = {
              domain: window.userInfo.domain,
              comentary: this.ds_response_text,
              workbook: this.item
            };
            this.$set(this.item, 'type_flow', 'APPROVE_OWNER');
            this.$set(this.item, 'document_id', this.item.id);
            TableauDashboardService.tableauWorkBookInitWorkFlow(_workbook).then(function (res) {
              if (res && res.code === 200) {
                if (res.success) {
                  tasks.toast.success('Check the ownership workflow');
                  if (_this2.$gtm.enabled() && window.dataLayer) {
                    window.dataLayer.push({
                      event: GA_EVENTS.ASSIGN_OPERATOR,
                      object: 'tbl_dashboard',
                      domain_object: _workbook.workbook.organization,
                      operator: _this2.stringToHash(_workbook.workbook.data_operator),
                      company_code: _this2.companyCode,
                      id_object: _workbook.workbook.id,
                      hash_email: _this2.stringToHash(userInfo.email),
                      module: 'data_platform'
                    });
                  }
                  // this.$toast.success("Check the ownership workflow")
                  _this2.onCancel();
                } else {
                  tasks.toast.error(res.message);
                  // this.$toast.warning(res.message)
                  _this2.onCancel();
                }
              }
            });
          }
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
          var data = _objectSpread(_objectSpread({
            response_text: this.response_text,
            domain: window.userInfo.domain
          }, this.item), {}, {
            status: 'APPROVED',
            type_flow: 'APPROVE_OWNER'
          });
          TableauDashboardService.tableauWorkBookSendAssignment(data).then(function (res) {
            if (res.code === 200 && res.success) {
              tasks.toast.success('Now this dashboard will available in "My Dashboards"');
              if (_this2.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.OWNERSHIP,
                  object: 'tbl_dashboard',
                  domain_object: _this2.item.organization,
                  operator: _this2.stringToHash(_this2.item.data_operator),
                  company_code: _this2.companyCode,
                  id_object: _this2.item.id,
                  hash_email: _this2.stringToHash(userInfo.email),
                  module: 'data_platform',
                  status: 'accepted'
                });
              }
              // this.$toast.success('Now this dashboard will available in "My Dashboards"')
              _this2.onCancel();
            } else {
              tasks.toast.error(res.message);
              // this.$toast.warning(res.message)
              _this2.onCancel();
            }
          });
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
          if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
            tasks.toast.error('No change has been made to the request');
            // this.$toast.warning("No change has been made to the request")
            return;
          }
          this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.CHANGE_METADATA);
          this.$set(this.item, 'document_id', this.item.id);
          var _workbook2 = {
            domain: window.userInfo.domain,
            comentary: this.response_text,
            workbook: this.item
          };
          TableauDashboardService.tableauWorkBookInitWorkFlow(_workbook2).then(function (res) {
            if (res && res.code === 200) {
              if (res.success) {
                tasks.toast.success('Successful request');
                if (_this2.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.CHANGE_METADATA,
                    object: 'tbl_dashboard',
                    domain_object: _workbook2.workbook.organization,
                    operator: _this2.stringToHash(_workbook2.workbook.data_operator),
                    company_code: _this2.companyCode,
                    id_object: _workbook2.workbook.id,
                    hash_email: _this2.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
                // this.$toast.success("Successful request")
                _this2.onCancel();
              } else {
                tasks.toast.error(res.message);
                // this.$toast.warning(res.message)
                _this2.onCancel();
              }
            }
          });
        }
      }

      /* if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
        if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
          if (this.item.data_operator.trim() === '') {
            this.valid.data_operator = false
            return
          } else if (this.item.data_operator.trim() !== '' && (!this.item.data_operator || !this.email_regex.test(this.item.data_operator))) {
            this.dangerMessage = 'Please check data operator email format (example@domain.com.pe)'
            this.dismissCountDown = this.dismissSecs
            return
          }
           const workbook = {
            domain: window.userInfo.domain,
            workbook: this.item
          }
           apiTableau.tableauWorkBookAddUpdate(workbook).then((res) => {
            this.isSend = false
            console.log('res: ', res)
            if (res && res.code === 200) {
              if (res.success) {
                alert('Workbook fields updated!')
                this.onCancel()
                this.$emit('onSave', workbook.workbook)
              } else {
                alert(res.message)
                this.onCancel()
              }
            }
          })
        } else {
          if (this.item.organization.trim() === '') {
            this.valid.organization = false
            isValid = false
          }
           if (this.item.data_operator.trim() === '') {
            this.valid.data_operator = false
            isValid = false
          }
          if (this.item.kdomain.trim() === '') {
            this.valid.kdomain = false
            isValid = false
          }
          if (this.item.ksubdomain.trim() === '') {
            this.valid.ksubdomain = false
            isValid = false
          }
           if (!this.item.object_description || !this.item.object_description.trim()) {
            this.dangerMessage =
              'Please check Table Description (The following characters are not allowed (,) (|) and (line break))'
            this.dismissCountDown = this.dismissSecs
            return
          }
           if (isValid) {
            const workbook = {
              domain: window.userInfo.domain,
              comentary: this.ds_response_text,
              workbook: this.item
            }
            this.$set(this.item, 'type_flow', 'APPROVE_OWNER')
            this.$set(this.item, 'document_id', this.item.id)
            apiTableau.tableauWorkBookInitWorkFlow(workbook).then((res) => {
              if (res && res.code === 200) {
                if (res.success) {
                  alert('Successful request')
                  this.onCancel()
                } else {
                  alert(res.message)
                  this.onCancel()
                }
              }
            })
          }
        }
      } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
        if (response_text.trim() === '') {
          this.dangerMessage = 'Please complete Response reason'
          this.dismissCountDown = this.dismissSecs
          isValid = false
          this.valid.response_text = false
          return
        }
        if (isValid) {
          const data = {
            response_text: this.response_text,
            domain: window.userInfo.domain,
            ...this.item,
            status: 'APPROVED',
            type_flow: 'APPROVE_OWNER'
          }
          apiTableau.tableauWorkBookSendAssignment(data).then((res) => {
            if (res.code === 200) {
              alert('Now this dashboard will available in "My Dashboards"')
              this.onCancel()
            }
          })
        }
      } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        if (this.item.organization.trim() === '') {
          this.valid.organization = false
          isValid = false
        }
        if (this.item.data_operator.trim() === '') {
          this.valid.data_operator = false
          isValid = false
        }
        if (this.item.kdomain.trim() === '') {
          this.valid.kdomain = false
          isValid = false
        }
        if (this.item.ksubdomain.trim() === '') {
          this.valid.ksubdomain = false
          isValid = false
        }
        if (this.item.object_description.trim() === '') {
          this.dangerMessage =
            'Please check Table Description (The following characters are not allowed (,) (|) and (line break))'
          this.dismissCountDown = this.dismissSecs
          return
        }
         if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
          this.dangerMessage = 'No change has been made to the request'
          this.dismissCountDown = this.dismissSecs
          return
        }
         if (isValid) {
          this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.CHANGE_METADATA)
          this.$set(this.item, 'document_id', this.item.id)
           const workbook = {
            domain: window.userInfo.domain,
            comentary: this.response_text,
            workbook: this.item
          }
          apiTableau.tableauWorkBookInitWorkFlow(workbook).then((res) => {
            if (res && res.code === 200) {
              if (res.success) {
                alert('Successful request')
                this.onCancel()
              } else {
                alert(res.message)
                this.onCancel()
              }
            }
          })
        }
      }*/
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onDownloadCsv: function onDownloadCsv() {
      var tplMeta = this.item;
      var columns = ['name', 'owner_name', 'sheettype', 'title', 'caption'];
      var header = ['organization', 'object_name', 'kdomain', 'ksubdomain', 'data_operator', 'environment', 'path_name', 'object_owner', 'sensitive_data', 'object_description', 'datasource_name'];
      header = header.concat(columns);
      header = header.join(';');
      var body = [];
      body.push(header);
      var datasource_path = '';
      if (tplMeta.datasource_path && tplMeta.datasource_path.length) {
        datasource_path = tplMeta.datasource_path[0].dbname;
      }
      var data = [tplMeta.organization, tplMeta.object_name, tplMeta.kdomain, tplMeta.ksubdomain, tplMeta.data_operator, tplMeta.environment, tplMeta.path_name, tplMeta.object_owner, tplMeta.sensitive_data ? 'true' : 'false', tplMeta.object_description, datasource_path];
      if (tplMeta.views && tplMeta.views.length) {
        tplMeta.views.forEach(function (item) {
          var row = [].concat(data);
          for (var i = 0; i < columns.length; i++) {
            row.push(item[columns[i]]);
          }
          body.push(row.join(';'));
        });
      } else {
        body.push(data.join(';'));
      }
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var encoded = encodeURIComponent(universalBOM + body.join('\n'));
      var url = "data:text/csv; charset=utf-8,".concat(encoded);
      a.href = url;
      a.download = "Workbook-".concat(tplMeta.path_name, "_").concat(tplMeta.object_name, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    },
    onUpdateTabActivate: function onUpdateTabActivate(newTabIndex, oldTabIndex, event) {
      this.txtCancelar = 'Cancel';
      this.showBtnAceptar = true;
      this.showDownloadCsv = true;
      if (newTabIndex === 1) {
        this.showDownloadCsv = false;
      }
      if (newTabIndex >= 2) {
        this.showDownloadCsv = false;
        this.txtCancelar = 'Close';
        this.showBtnAceptar = false;
      }
    }
  }
};